import { useSelector } from 'react-redux'
import { authSlice } from '../../../authSlice'

export const useSignUpHash = () => {
  const signupFields = useSelector(authSlice.selectors.selectSignupFields)

  return signupFields?.hash
}
